import { render, staticRenderFns } from "./embryoAll.vue?vue&type=template&id=20d4bf22&scoped=true"
import script from "./embryoAll.vue?vue&type=script&lang=js"
export * from "./embryoAll.vue?vue&type=script&lang=js"
import style0 from "./embryoAll.vue?vue&type=style&index=0&id=20d4bf22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d4bf22",
  null
  
)

export default component.exports